import React from "react";

export const UiImageThumbailGradient = (props) => {
  return (
    <>
      <div className="df-image-thumbnail-gradiant">
        <div className={props?.className}>
          {props?.logo && <img src={props.logo} />}
          {props?.textLogo && <h1>{props.textLogo}</h1>}
        </div>
      </div>
    </>
  );
};
